import React from "react";
import GuestApp from "./GuestApp/GuestApp";

const AppIndex = () => {
  return <GuestApp />;
};

export default AppIndex;
